import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fd5b6db"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "WaveInvoicePanelInformation h-full" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col items-center justify-center text-sm select-none text-gray-400 py-8 px-6"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "Загрузка данных накладной...", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, "При получении данных накладной произошла ошибка", -1))
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 1,
  class: "WaveInvoicePanelInformation__content"
}
const _hoisted_7 = { class: "py-8 px-6" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Информация по накладной", -1))
const _hoisted_9 = { class: "mt-3 grid grid-cols-2 gap-3" }
const _hoisted_10 = { class: "mt-3 grid grid-cols-2 gap-3" }
const _hoisted_11 = { class: "mt-3 grid grid-cols-2 gap-3" }
const _hoisted_12 = { class: "mt-3 grid grid-cols-2 gap-3" }
const _hoisted_13 = { class: "border-t border-gray-200 px-6 py-4 flex items-center justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_additional_services_block = _resolveComponent("additional-services-block")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_loading || _ctx.state.is_failed || !_ctx.state.invoice)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_loader, { class: "primary" }),
                _hoisted_3
              ], 64))
            : (_ctx.state.is_failed)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_4,
                  _createVNode(_component_new_button, {
                    class: "NewButton--outline mt-1",
                    onClick: _ctx.loadInvoice
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Обновить ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ], 64))
              : (!_ctx.state.invoice)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Нет данных"))
                : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_the_input, {
              class: "mt-3",
              placeholder: "№ Накладной",
              value: _ctx.state.invoice.invoice_number,
              disabled: "",
              "is-static": ""
            }, null, 8, ["value"]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_the_input, {
                placeholder: "Физ вес",
                value: _ctx.form.weight,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.weight) = $event)),
                "is-static": "",
                disabled: "",
                "is-invalid": _ctx.form$.weight.$error,
                "validation-errors": _ctx.form$.weight.$errors
              }, null, 8, ["value", "is-invalid", "validation-errors"]),
              _createVNode(_component_the_input, {
                placeholder: "Объемный вес",
                value: _ctx.form.volumeWeight,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.volumeWeight) = $event)),
                "is-static": "",
                disabled: "",
                "is-invalid": _ctx.form$.volumeWeight.$error,
                "validation-errors": _ctx.form$.volumeWeight.$errors
              }, null, 8, ["value", "is-invalid", "validation-errors"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_the_input, {
                placeholder: "Клиент",
                value: _ctx.form.title,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.title) = $event)),
                "is-static": "",
                disabled: "",
                "is-invalid": _ctx.form$.title.$error,
                "validation-errors": _ctx.form$.title.$errors
              }, null, 8, ["value", "is-invalid", "validation-errors"]),
              _createVNode(_component_the_input, {
                placeholder: "Кол-во мест",
                value: _ctx.form.places,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.places) = $event)),
                "is-static": "",
                disabled: "",
                "is-invalid": _ctx.form$.places.$error,
                "validation-errors": _ctx.form$.places.$errors
              }, null, 8, ["value", "is-invalid", "validation-errors"])
            ]),
            _createVNode(_component_the_input, {
              placeholder: "Адрес доставки",
              class: "mt-3",
              value: _ctx.form.fullAddress,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.fullAddress) = $event)),
              "is-static": "",
              disabled: "",
              "is-invalid": _ctx.form$.fullAddress.$error,
              "validation-errors": _ctx.form$.fullAddress.$errors,
              "with-tooltip": ""
            }, null, 8, ["value", "is-invalid", "validation-errors"]),
            _createVNode(_component_the_input, {
              class: "mt-3",
              placeholder: "Получатель",
              value: _ctx.form.fullName,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.fullName) = $event)),
              "is-static": "",
              disabled: "",
              "is-invalid": _ctx.form$.fullName.$error,
              "validation-errors": _ctx.form$.fullName.$errors
            }, null, 8, ["value", "is-invalid", "validation-errors"]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_the_input, {
                placeholder: "Телефон",
                value: _ctx.form.phone,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.phone) = $event)),
                "is-static": "",
                disabled: "",
                "is-invalid": _ctx.form$.phone.$error,
                "validation-errors": _ctx.form$.phone.$errors,
                maska: _ctx.PHONE_NUMBER_MASK
              }, null, 8, ["value", "is-invalid", "validation-errors", "maska"]),
              _createVNode(_component_the_input, {
                placeholder: "Доп телефон",
                value: _ctx.form.additional_phone,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.additional_phone) = $event)),
                "is-static": "",
                disabled: "",
                "is-invalid": _ctx.form$.additional_phone.$error,
                "validation-errors": _ctx.form$.additional_phone.$errors,
                maska: _ctx.PHONE_NUMBER_MASK
              }, null, 8, ["value", "is-invalid", "validation-errors", "maska"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_the_input, {
                placeholder: "Направление",
                value: _ctx.form.direction,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.direction) = $event)),
                "is-static": "",
                disabled: "",
                "is-invalid": _ctx.form$.direction.$error,
                "validation-errors": _ctx.form$.direction.$errors
              }, null, 8, ["value", "is-invalid", "validation-errors"]),
              _createVNode(_component_the_input, {
                placeholder: "Менеджер",
                value: _ctx.form.manager,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.manager) = $event)),
                "is-static": "",
                disabled: "",
                "is-invalid": _ctx.form$.manager.$error,
                "validation-errors": _ctx.form$.manager.$errors
              }, null, 8, ["value", "is-invalid", "validation-errors"])
            ]),
            _createVNode(_component_the_input, {
              class: "mt-3",
              placeholder: "Дата доставки",
              "is-static": "",
              disabled: "",
              value: _ctx.state.invoice.delivery_date
            }, null, 8, ["value"]),
            _createVNode(_component_the_input, {
              class: "mt-3",
              placeholder: "Контрагент",
              value: _ctx.state.invoice.company_name,
              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.invoice.company_name) = $event)),
              disabled: ""
            }, null, 8, ["value"]),
            _createVNode(_component_additional_services_block, {
              title: "Доп. услуги отправителя",
              key: "NewSenderService",
              "is-visible": _ctx.isCanShowSenderServices,
              services: _ctx.state.invoice.order_additional_services_values
            }, null, 8, ["is-visible", "services"]),
            _createVNode(_component_additional_services_block, {
              title: "Доп. услуги получателя",
              key: "NewReceiverService",
              "is-visible": _ctx.isCanShowReceiverServices,
              services: _ctx.state.invoice.additional_services_values
            }, null, 8, ["is-visible", "services"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_new_button, {
              style: {"width":"150px"},
              onClick: _ctx.emitCancel
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Закрыть ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
  ]))
}